import {
  ExtendedVCenter,
  PropertyMetadata,
  VcfInfraData
} from 'vrlcm-gui-types';
import { ValidateScaleOutOvaResult } from '../../../components/environments/actions/pre-add-component-alert/types';
import * as Constants from '../../../constants/action-constants';
export interface InitializeStepInfra {
  type: Constants.INITIALIZE_STEP_INFRA;
}

export interface InitializeStepInfraSuccess {
  type: Constants.INITIALIZE_STEP_INFRA_SUCCESS;
  payload: {
    vCenters: ExtendedVCenter[];
    properties: PropertyMetadata[];
    vcfInfraData?: VcfInfraData;
    validateScaleOutOvaResult?: ValidateScaleOutOvaResult;
  };
}

export interface InitializeStepInfraFailed {
  type: Constants.INITIALIZE_STEP_INFRA_FAILED;
}

export type StepInfraAction =
  | InitializeStepInfra
  | InitializeStepInfraFailed
  | InitializeStepInfraSuccess;

export const initializeStepInfra = (): InitializeStepInfra => ({
  type: Constants.INITIALIZE_STEP_INFRA
});

export const initializeStepInfraSuccess = (
  vCenters: ExtendedVCenter[],
  properties: PropertyMetadata[],
  vcfInfraData?: VcfInfraData,
  validateScaleOutOvaResult?: ValidateScaleOutOvaResult
): InitializeStepInfraSuccess => ({
  payload: { vCenters, properties, vcfInfraData, validateScaleOutOvaResult },
  type: Constants.INITIALIZE_STEP_INFRA_SUCCESS
});

export const initializeStepInfraFailed = (): InitializeStepInfraFailed => ({
  type: Constants.INITIALIZE_STEP_INFRA_FAILED
});
